import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const ModalCloseIcon = ({ id, size = 'small', onClick, className, disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.ModalClose}
      alt="img"
      className={cn(styles.icon, getIconClasses(size, disabled), className)}
      onClick={(event) => {
        if (!disabled) onClick?.(event);
      }}
    />
  );
};
